// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import { withRouter } from 'react-router-dom';
import ProductSelectionComponent from '../../common/product-selection/ProductSelectionComponent';
import NewProductLayout from '../../common/new-product-layout/NewProductLayoutComponent';
import type { ProductSelectionTilesProps } from '../../common/product-selection/product-selection-tiles/ProductSelectionTilesComponent';
import AnalyticsClient from '../../../../clients/AnalyticsClient';
import productEvents from '../../../../analytics/events/products';

type Actions = {
  configureCreationSettings: (Object, string) => void,
};

type Props = ProductSelectionTilesProps & {
  isLoading: boolean,
  isSingleProductType: boolean,
  actions: Actions,
  runtimeConfig: {
    api: string,
  },
  parentLocation: string | null,
  config: Object,
  location: {
    pathname: string,
  },
};

class CreationComponent extends React.Component<Props> {
  static displayName = 'CreationPage';

  static contextTypes = {
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    parentLocation: null,
  };

  static propTypes = {
    config: PropTypes.object.isRequired,
    actions: PropTypes.shape({
      configureCreationSettings: PropTypes.func.isRequired,
    }).isRequired,
    parentLocation: PropTypes.string,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
  };

  UNSAFE_componentWillMount() {
    this.props.actions.configureCreationSettings(this.props.config.productSizesAvailable, this.props.runtimeConfig.api);
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (nextProps.config !== this.props.config) {
      this.props.actions.configureCreationSettings(nextProps.config.productSizesAvailable, nextProps.runtimeConfig.api);
    }
  }

  render() {
    return (
      <NewProductLayout
        parentLocation={this.props.parentLocation}
        onBackCallback={() => AnalyticsClient.trackEvent(productEvents.backButtonNewProduct())}
        onCloseCallback={() => AnalyticsClient.trackEvent(productEvents.closeButtonNewProduct())}
      >
        <ProductSelectionComponent {...this.props} creationCategory="create" />
      </NewProductLayout>
    );
  }
}

export default withRouter(CreationComponent);
